/**
 * 四页图层白名单与默认开启项（P1）
 * 切换路由时：只显示当前页白名单内已加载图层
 */

export const PAGES = [
  { id: "home", path: "/", name: "总览", subtitle: "综合态势" },
  { id: "supply", path: "/supply", name: "供水", subtitle: "管网 · 二供" },
  { id: "drainage", path: "/drainage", name: "排水", subtitle: "管网 · 厂站" },
  { id: "hydro", path: "/hydro", name: "水雨情", subtitle: "水文 · 气象" },
];

/** 各页可出现的图层 key（面板列表） */
export const PAGE_LAYER_KEYS = {
  home: [
    "polder",
    "dike",
    "gate",
    "warehouse",
    "shelter",
    "rescue",
    "sq",
    "yq",
    "jsjc",
    "gq",
  ],
  supply: [
    "supplyPipe50",
    "supplyPipe100",
    "supplyPipe200",
    "supplyPipe300",
    "supplyPipe400",
    "supplyPressure",
    "supplyPump",
    "supplyHydrant",
  ],
  drainage: [
    "drainPipe200",
    "drainPipe400",
    "drainPipe600",
    "drainPipe800",
    "drainPipe1000",
    "drainPipe1200",
    "drainPipe1400",
    "drainPipe2000",
    "drainPump",
    "agriPump",
    "wwtp",
    "drainUser",
    "drainManhole",
  ],
  hydro: ["polder", "gate", "sq", "yq", "jsjc", "gq"],
};

/** 进入页面时自动加载并显示的图层 */
export const PAGE_BOOT_KEYS = {
  home: ["polder", "dike", "gate", "warehouse", "shelter", "rescue", "jsjc"],
  supply: ["supplyPipe400", "supplyPressure", "supplyPump"],
  drainage: [
    "drainPipe200",
    "drainPipe400",
    "drainPipe600",
    "drainPipe800",
    "drainPipe1000",
    "drainPipe1200",
    "drainPipe1400",
    "drainPipe2000",
    "drainPump",
    "agriPump",
    "wwtp",
  ],
  hydro: ["polder", "sq", "yq", "jsjc", "gq", "gate"],
};
